import { KatList, KatPopover } from "@amzn/katal-react";
import React, { type FC, type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import type { ReferencedDocument } from "src/api/interfaces/inbound_document";
import {
  DEFAULT_TRANSLATION_CONFIG,
  DEFAULT_TRANSLATION_NS,
} from "src/components/TranslatedField/TranslationKey";
import styles from "./referenced_documents_popover_styles.module.scss";

interface ReferencedDocumentsPopoverProps {
  trigger: ReactNode;
  referencedDocuments: ReferencedDocument[];
}

const MAX_ITEMS = 20;

const ReferencedDocumentsPopover: FC<ReferencedDocumentsPopoverProps> = ({
  trigger,
  referencedDocuments,
}) => {
  const { t } = useTranslation(
    DEFAULT_TRANSLATION_NS,
    DEFAULT_TRANSLATION_CONFIG
  );

  const visible = referencedDocuments.slice(0, MAX_ITEMS);
  const hasMore = referencedDocuments.length > MAX_ITEMS;

  return (
    <KatPopover triggerType="click" position="bottom-start">
      {trigger}
      <div className={styles.container}>
        <h5>{t("aic_doc_page_referenced_documents_title")}</h5>
        <KatList variant="ordered" className={styles.list}>
          {visible.map(({ documentId, documentType }) => (
            <li key={`${documentId}|${documentType}`}>
              {documentType}: {documentId}
            </li>
          ))}
        </KatList>
        {hasMore && (
          <footer className={styles.footer}>
            {t("aic_doc_page_referenced_documents_popover_more")}
          </footer>
        )}
      </div>
    </KatPopover>
  );
};

export default ReferencedDocumentsPopover;
